@if (currentCommunity) {
    <mat-card class="communicationCard">
        <mat-card-header>
            <mat-card-title>Communication Preferences</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            @if (!currentCommunity?.communication_preferences) {
                <p>
                    By being a member of the {{ currentCommunity?.name }}, you have given consent to receiving
                    transactional
                    emails from the Community - as outlined in our Terms and Conditions and Privacy Policy.
                </p>
                <p>
                    The receipt of these emails is important to help you keep up to date on the Community and its
                    content.
                </p>
                <p>
                    If you no longer wish to participate in this community, you can use 'Leave Community' below.
                    Leaving a community does not permanently delete your account and all associated personal data.
                </p>
            }
            @if (currentCommunity?.communication_preferences) {
                <div [innerHTML]="currentCommunity?.communication_preferences_text_rendered"
                     class="ck-editorControl"></div>
            }
            <p>To permanently delete your account and associated personal data,
                <a routerLink="/account-deletion">request account deletion</a>.</p>
        </mat-card-content>
        @if (isLoggedIn() && currentCommunity) {
            <mat-card-actions class="flex-row flex-space-between">
                <button (click)="leave()" color="warn" mat-raised-button>Leave Community</button>
            </mat-card-actions>
        }
        @if (!isLoggedIn()) {
            <mat-card-actions class="flex-row flex-space-between">
                <button [routerLink]="['/login']" color="primary" mat-raised-button>Login to manage communication
                    preferences
                </button>
            </mat-card-actions>
        }
    </mat-card>
}
